import { useEffect, useState } from "react";
import { BaseURL, test } from "../../../base/env";
import { TComma } from "../../../base/utils";
import { Note, Page } from "../../../helbest";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { API } from "../../../request/api";
import styles from "./OrdersDetails.module.css";
import { useParams } from "react-router-dom";
import Loading from "../../components/Loading/Loading";

const OrdersDetails = (props) => {
  const [loading, set_loading] = useState(true);
  const [orders_detail, set_orders_detail] = useState([]);
  const params = useParams();

  const __get_orders_detail = () => {
    API.get
      .userOrders(params.id)
      .then((response) => {
        if (response.success) {
          set_orders_detail(response.data);
          set_loading(false);
        } else {
          Note.error(response.message);
        }
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  };

  useEffect(() => {
    __get_orders_detail();

    // eslint-disable-next-line
  }, []);

  return (
    <Page
      className="page-profile"
      // title="My Orders"
      back={true}
      address="/orders/"
      mobileContainer
      customHeader={<HeaderBack title="Order Detail" />}
      headerFix
    >
      <div className="factors-holder factors-scroll hei-100p page-factor-factors-container">
        {loading ? (
          <div className="text-center mt-5">
            <Loading />
          </div>
        ) : (
          <div className="factors-item page-factor-factors-item">
            <div className="orders-detail-info">
              <div className={styles.OrderDate}>
                <label> Order Date: </label>
                <span>
                  <span className="pa-l-5"> {orders_detail.time} </span>
                  <span> {orders_detail.date} </span>
                </span>
              </div>
              <hr />
              <div className={"w-full"}>
                <label className={styles.LabelInfo}> Paid Amount </label>
                <span>
                  <span className="orders-toman-text"> OMR </span>
                  <span className="orders-toman-price">
                    {" "}
                    {TComma(orders_detail.amount)}{" "}
                  </span>
                </span>
              </div>
              <div className={"w-full"}>
                <label className={styles.LabelInfo}> Delivery Amount </label>
                <span>
                  <span className="orders-toman-text"> OMR </span>
                  <span className="orders-toman-price">
                    {" "}
                    {TComma(orders_detail.delivery_amount)}{" "}
                  </span>
                </span>
              </div>
              <div className={"w-full"}>
                <label className={styles.LabelInfo}> Service Amount </label>
                <span>
                  <span className="orders-toman-text"> OMR </span>
                  <span className="orders-toman-price">
                    {" "}
                    {TComma(orders_detail.service_amount)}{" "}
                  </span>
                </span>
              </div>
              <div className={"w-full"}>
                <label className={styles.LabelInfo}> Used Credit </label>
                <span>
                  <span className="orders-toman-text"> OMR </span>
                  <span className="orders-toman-price">
                    {" "}
                    {TComma(orders_detail.credit_amount)}{" "}
                  </span>
                </span>
              </div>
              <div className={"w-full"}>
                <label className={styles.LabelInfo}> Discount Amount </label>
                <span>
                  <span className="orders-toman-text"> OMR </span>
                  <span className="orders-toman-price">
                    {" "}
                    {TComma(orders_detail.discount_amount)}{" "}
                  </span>
                </span>
              </div>
              {/* <hr />
                  <div className="w-full">
                    <label>پرداخت شده</label>
                    <span>
                      <span className="orders-toman-price">
                        {TComma(orders_detail?.payable_amount)}
                      </span>
                      <span className="orders-toman-text"> OMR </span>
                    </span>
                  </div> */}
            </div>
            <h5 className="orders-detail-purchased-header">Order Items</h5>
            <hr />

            {orders_detail?.order_lines?.map((x, i) => (
              <div className="orders-detail-products-box" key={i}>
                <div className="w-full">
                  <img
                    className="order-img"
                    loading="lazy"
                    src={test ? x.image : BaseURL + x.image}
                    alt={i}
                  />
                  <div className={styles.TextInfo}>
                    <div className="w-full">
                      <span> {x.product_name} </span>
                    </div>
                    <div>
                      <label> Quality: </label>
                      <span> {x.quantity} </span>
                    </div>
                  </div>
                </div>
                <div className="w-full mt-2">
                  <div className="orders-detail-countainer">
                    <label> Used Number </label>
                    <span> {x.used} </span>
                  </div>
                  <div className="orders-detail-countainer">
                    <label> Returned Number </label>
                    <span> {x.returned} </span>
                  </div>
                  <div className="orders-detail-countainer">
                    <label> Expired Number </label>
                    <span> {x.expired} </span>
                  </div>
                </div>
                <br />
                <div className="w-full">
                  <label className={styles.LabelInfo}> Service Type </label>
                  {/* <span>
                        <span> {TComma(x.amount)} </span>
                        <span className="orders-toman-text"> OMR </span>
                      </span> */}
                </div>
                <div className="w-full">
                  <label className={styles.LabelInfo}> Appointment Time </label>
                  {/* <span>
                        <span> {TComma(x.amount)} </span>
                        <span className="orders-toman-text"> OMR </span>
                      </span> */}
                </div>
                <div className="w-full">
                  <label className={styles.LabelInfo}> Amount </label>
                  {/* <span>
                        <span> {TComma(x.amount)} </span>
                        <span className="orders-toman-text"> OMR </span>
                      </span> */}
                </div>
                <div className="w-full">
                  <label className={styles.LabelInfo}> Discount Amount </label>
                  {/* <span>
                        <span> {TComma(x.amount)} </span>
                        <span className="orders-toman-text"> OMR </span>
                      </span> */}
                </div>
                <div className="w-full">
                  <label className={styles.LabelInfo}> Paid Amount </label>
                  {/* <span>
                        <span> {TComma(x.amount)} </span>
                        <span className="orders-toman-text"> OMR </span>
                      </span> */}
                </div>
                {/* <div className="w-full">
                      <label> تاریخ مراجعه </label>
                      <span>
                        <span className="pa-l-5"> {orders_detail.time} </span>
                        <span> {orders_detail.date} </span>
                      </span>
                    </div>
                    <div className="w-full">
                      <label> مبلغ کل </label>
                      <span>
                        <span> {TComma(x.amount)} </span>
                        <span className="orders-toman-text"> OMR </span>
                      </span>
                    </div>
                    <div className="w-full">
                      <label> مقدار تخفیف </label>
                      <span>
                        <span> {TComma(x.product_discount_amount)} </span>
                        <span className="orders-toman-text"> OMR </span>
                      </span>
                    </div>
                    <div className="w-full">
                      <label> پرداخت شده </label>
                      <span>
                        <span> {TComma(x.payable_amount)} </span>
                        <span className="orders-toman-text"> OMR </span>
                      </span>
                    </div> */}
              </div>
            ))}
          </div>
        )}
      </div>
    </Page>
  );
};

export default OrdersDetails;
